// extracted by mini-css-extract-plugin
export default {"homeMain":"Home_homeMain__-6tfH","homeNearby":"Home_homeNearby__1IdoD"};